var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".svgicon-logout-a{fill:#ff1d48;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.375 23.375) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svgicon-logout-a",
    d: "M13.5,16.894h9.12l-2.1,2.149,1.438,1.437,4.615-4.615L21.962,11.25l-1.49,1.438,2.149,2.149H13.5Z",
    transform: "translate(-3.202 -2.49)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.375 3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svgicon-logout-a",
    d: "M13.361,21.322a7.947,7.947,0,0,1,0-15.894,7.878,7.878,0,0,1,5.6,2.317l1.457-1.457a10.626,10.626,0,0,0-1.332-1.115,10.008,10.008,0,1,0,1.327,15.284L18.962,19A7.869,7.869,0,0,1,13.361,21.322Z",
    transform: "translate(-3.375 -3.375)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-logout-a",
    d: "M31.458,17.958h.058v.058h-.058Z",
    transform: "translate(-12.256 -7.987)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d7172697.svg";
export { ForwardRef as ReactComponent };